import * as React from 'react'
import { ReactElement } from 'react'
import DropdownConnect, { DropdownConnectProps } from '../Connect/DropdownConnect'
import { FileAction, FileStatus } from '../../../config/fileConfig'
import { FileListItemDto, mapFileOptions, sortFileOptions } from '../../../context/FileContext'
import { useSelector } from 'react-redux'
import { DataPromise } from '../../../context/AxiosContext'
import { Store } from '../../../reducers'
import { SortSetting } from '../../../config/settingConfig'
import { useSettings } from '../../../hooks/useSettings'
import useAxios from '../../../hooks/useAxios'
import { useTranslation } from 'react-i18next'

export type FileDropdownMapperProps = {
    idProp?: string
    includeArchived?: boolean
    initialValues?: string[]
}

type Props = FileDropdownMapperProps & DropdownConnectProps<FileListItemDto>

export const fileDropdownMapper =
    (props: FileDropdownMapperProps, fileSort?: SortSetting) => (items: FileListItemDto[]) =>
        items
            .filter(
                (file: FileListItemDto) =>
                    props.includeArchived ||
                    props.initialValues?.some(id => id === file.id) ||
                    file.status === FileStatus.Open,
            )
            .map(mapFileOptions<FileListItemDto>(fileSort, props.idProp || 'id'))
            .sort(sortFileOptions<FileListItemDto>(fileSort))

export default function FileDropdown(props: Props): ReactElement {
    const files = useSelector<Store, DataPromise<FileListItemDto[]>>(state => state.files.list)
    const settings = useSettings()
    const axios = useAxios()
    const { t: translate } = useTranslation()

    return (
        <DropdownConnect<FileListItemDto>
            label={translate('base.filepicker.label')}
            placeholder={`${translate('base.tagpicker.placeholder.prefix')} ${translate('base.filepicker.placeholder', { count: 1 })}`}
            {...props}
            items={files}
            load={() => ({
                type: FileAction.GetList,
                payload: axios.get('/file/list'),
            })}
            reset={() => ({ type: FileAction.ResetList })}
            mapper={fileDropdownMapper(props, settings?.fileSort)}
        />
    )
}
